export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="rounded-2xl bg-background-100 border border-background-200/70 p-8 md:p-12">
          <div className="text-center mb-8">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4">
              <i className="ri-information-line"></i>关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">关于丫丫</h2>
          </div>

          <div className="space-y-5 text-sm text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            <p>
              丫丫影院创立于2020年，是国内领先的免费高清影视在线观看平台。我们致力于为影迷剧迷提供海量、优质、流畅的观影体验，让每个人都能轻松享受影视带来的乐趣。
            </p>
            <p>
              平台目前收录超过20000部影视资源，涵盖国产剧、韩剧、美剧、日剧、动漫、综艺及院线电影等全品类内容。每日同步更新热播剧集与最新电影，确保用户第一时间看到想看的作品。
            </p>
            <p>
              我们坚持"免费、高清、不缓冲"的核心理念，无需注册登录即可直接观看全集。未来，丫丫影院将持续优化播放体验，扩充内容库，成为您最信赖的在线观影伙伴。
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8 mt-8 pt-8 border-t border-background-200">
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-primary-500">2020</div>
              <div className="text-xs text-foreground-400 mt-1">创立年份</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-accent-500">20000+</div>
              <div className="text-xs text-foreground-400 mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-primary-500">1000万+</div>
              <div className="text-xs text-foreground-400 mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-heading font-bold text-accent-500">每日更新</div>
              <div className="text-xs text-foreground-400 mt-1">更新节奏</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}